/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createAllotmentApprovalFromDiscriminatorValue, type AllotmentApproval } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Allotment/GetForApproval
 */
export interface GetForApprovalRequestBuilder extends BaseRequestBuilder<GetForApprovalRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<AllotmentApproval[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<AllotmentApproval[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const GetForApprovalRequestBuilderUriTemplate = "{+baseurl}/Allotment/GetForApproval";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetForApprovalRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: GetForApprovalRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createAllotmentApprovalFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
